var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47,58.647h8v24.546c0,4.11-3.252,7.454-7.25,7.454H9.271c-3.998,0-7.25-3.344-7.25-7.454L2,14.104 c0-4.112,3.262-7.456,7.271-7.456H47.75c3.998,0,7.25,3.344,7.25,7.455v23.545h-8v-23H10l0.021,68H47V58.647z M92.29,45.223 L74.658,27.59c-1.511-1.511-3.521-2.346-5.661-2.344c-2.137-0.001-4.144,0.835-5.65,2.347l5.657,5.652 c-0.003,0.003,10.801,10.806,10.801,10.806H45c-2.208,0.003-3.997,1.792-3.997,4c0,2.208,1.79,4.004,3.999,4.004h0.24 c0-0.003,44.22-0.003,44.22-0.003c1.618,0,3.076-0.975,3.695-2.47C93.776,48.087,93.435,46.367,92.29,45.223z M73.264,58.484 c0.003,0.003-4.206,4.212-4.206,4.212c0,0-5.714,5.713-5.714,5.713c1.507,1.512,3.513,2.348,5.65,2.347 c2.14,0.002,4.147-0.83,5.661-2.344l-0.285-0.291l0.288,0.288l4.266-4.266c-0.002-0.002,5.652-5.656,5.652-5.656L73.264,58.484z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitBlue);
export default __webpack_public_path__ + "static/media/exit-blue.3435053e796fb50816cda346f80ee443.svg";
export { ForwardRef as ReactComponent };